// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '5f53eca6-9739-474b-9ec7-1cbfe72205da',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -80,
        y: -60,
        width: 160,
        height: 130
      },
      parent: ''
    },
    {
      id: '0d29c9b7-8727-47cb-bd96-d0680add06bb',
      type: 'Container',
      name: 'lockContainer',
      className: '',
      x: 0,
      y: 51,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5f53eca6-9739-474b-9ec7-1cbfe72205da',
      stateByName: {
        locked: {
          visible: true
        }
      }
    },
    {
      id: '084d526c-74e0-44b4-aae9-86a51c5b5695',
      type: 'Container',
      name: 'bubbleSlot',
      className: '',
      x: 72,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5f53eca6-9739-474b-9ec7-1cbfe72205da',
      stateByName: {
        pointerRight: {
          x: -72
        }
      }
    },
    {
      id: '95c55c21-4eba-4e4e-a309-c26f0697db48',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -80,
      y: -19,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 160,
      height: 38,
      leftWidth: 20,
      topHeight: 19,
      rightWidth: 20,
      bottomHeight: 19,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Icon_Timer_Background',
      parent: '0d29c9b7-8727-47cb-bd96-d0680add06bb'
    },
    {
      id: '25dcbf82-7078-4ae4-9f37-3b86015563a7',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0d29c9b7-8727-47cb-bd96-d0680add06bb',
      data: {
        centerChildrenPadding: 6
      }
    },
    {
      id: '655b34cb-a77d-4034-b145-c697a6bf7809',
      type: 'Sprite',
      name: '',
      className: '',
      x: -54,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Icon',
      parent: '25dcbf82-7078-4ae4-9f37-3b86015563a7'
    },
    {
      id: '25b6e9f7-ae43-47fc-8130-48c790da1f8d',
      type: 'Text',
      name: 'unlockLevelText',
      className: '',
      x: 14,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level <nr>',
      localize: true,
      maxWidth: 108,
      maxHeight: 37,
      maxFontSize: 0,
      icons: [
        {
          key: '@new icon@',
          x: 0,
          y: 0,
          scale: {
            x: 1,
            y: 1
          },
          shadow: false,
          texture: ''
        }
      ],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#6e2009',
        stroke: 'white',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '25dcbf82-7078-4ae4-9f37-3b86015563a7'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'pointerRight'
  ],
  handleResize: false
} as const;

export class LevelLockMenuIconOverlayLayout {
  static raw = raw;
  root!: Container;
  lockContainer!: Container;
  bubbleSlot!: Container;
  unlockLevelText!: Text;
  centerChildren_SPL!: (Container & { data: typeof raw['list'][4]['data'] })[];
  StateName!: 'pointerRight';

  constructor() {
    populate(this, raw);
  }
}
